/**
 * useCan Hook
 * Check if user can perform an action on a subject
 */

import { useAbility } from './useAbility';
import { Action, Subject } from '../types';

export interface CanContext {
  readOnly?: boolean;
  [key: string]: any;
}

export const useCan = (action: Action, subject: Subject, context?: CanContext): boolean => {
  const ability = useAbility();
  const hasPermission = ability.can(action, subject);

  // If context specifies readOnly, check if action is allowed in readOnly mode
  if (context?.readOnly) {
    // In readOnly mode, only allow 'read' actions
    return hasPermission && action === 'read';
  }

  return hasPermission;
};
